import { useLayoutEffect } from 'react';
import { EditSinglePaymentActivity, PaymentFlowDoneAction } from '@melio/ap-activities';
import { FeatureFlags, useFeature } from '@melio/platform-feature-flags';
import { useConfig } from '@melio/platform-provider';
import { useNavigate } from '@melio/platform-utils';

import { usePaymentFlowIntuitConnect } from '@/hooks/accountingPlatforms.hooks';
import { useRouter } from '@/hooks/router.hooks';
import { PayDashboardTabs } from '@/types/payDashboard.types';

export const EditPaymentScreen = ({ paymentId, returnUrl }: { paymentId: string; returnUrl?: string }) => {
  const config = useConfig();
  const navigate = useNavigate();
  const { replaceToPayDashboardTab, generateNPEDashboardLink } = useRouter();
  const { loginToAccountPlatformAuth, isLoginToAccountPlatformAuthLoading } = usePaymentFlowIntuitConnect({
    redirectMethod: 'replace',
  });
  const shouldRedirectToNewDashboard = config.settings.newPayExperience.isEnabled;
  const [isNewPaymentFlowEnabled] = useFeature(FeatureFlags.NewPaymentFlow, false);

  useLayoutEffect(() => {
    if (isNewPaymentFlowEnabled) {
      navigate({ pathname: `/payment/${paymentId}/edit` }, { state: { returnUrl }, replace: true });
    }
  }, [isNewPaymentFlowEnabled, paymentId, returnUrl, navigate]);

  const handleClose = () => {
    if (returnUrl) {
      return navigate(returnUrl);
    }
    replaceToPayDashboardTab(PayDashboardTabs.Scheduled, paymentId);
  };

  const handleDone = (paymentId: string, action: PaymentFlowDoneAction) => {
    if (action === 'syncQBOAccountingPlatform') {
      return loginToAccountPlatformAuth();
    }
    if (shouldRedirectToNewDashboard) {
      return navigate(generateNPEDashboardLink('payments'));
    }
    replaceToPayDashboardTab(PayDashboardTabs.Scheduled);
  };

  return (
    <EditSinglePaymentActivity
      paymentId={paymentId}
      onBack={handleClose}
      onClose={handleClose}
      onDone={handleDone}
      isLoading={isLoginToAccountPlatformAuthLoading}
    />
  );
};
